import { validateStoredRegion } from '../content-value/value/utilities';

function useLocalStorage(itemKey: string) {
  const storedRegion = localStorage.getItem(itemKey);
  validateStoredRegion(storedRegion as string);

  return storedRegion;
}

export default useLocalStorage;
